/** API route map: URLS.Controller.SwipeClock */
export const SwipeClock = {
      Name: 'SwipeClock',
      GenerateEmployeeJWT: '/generate-employee-jwt',
};
